<script setup lang="ts">
import PaymentPage from "@/components/PaymentPage.vue";
</script>

<template>
  <PaymentPage />
</template>

<style scoped lang="scss"></style>
